import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import ContentClear from 'material-ui/svg-icons/content/remove-circle';
import FuseTheme from "../global/theme";

const styles = {
    buttonContainer: {
        margin: '0 0 1em 16px'
    },
    fieldDescription: {
        flex: '1 1 40%',
        display: 'block',
        width: 'auto',
        height: '2em',
        fontSize: '12px',
        color: FuseTheme.palette.lightTextColor,
    },
};
const filterLabel = (props, label, locationId) => {
    let labelText = (label) ? label : 'Zero out Inventory for Location ';
    return (locationId) ? (
        <span>{labelText}{locationId}</span>
    ) : (
        ''
    )
};

const ZeroOutLocationInventory = ({basePath = '', record = {}, instructions = '', label = '', filterValues = {}, locationId = ''}) => (
    <div style={styles.buttonContainer}>
        <span style={styles.fieldDescription}>{instructions}</span>
        <RaisedButton
            primary
            label={filterLabel(filterValues, label, locationId)}
            icon={<ContentClear/>}
            containerElement={<Link to={`${basePath}/${locationId}`}/>}
        />
    </div>
);

ZeroOutLocationInventory.propTypes = {
    basePath: PropTypes.string,
    filterValues: PropTypes.object,
    instructions: PropTypes.string,
    locationId: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
};

ZeroOutLocationInventory.defaultProps = {
    style: {padding: 0},
};

export default ZeroOutLocationInventory;


// WEBPACK FOOTER //
// ./src/Fuse/buttons/ZeroOutLocationInventoryButton.js